import BaseApiAction from '@Actions/base-api-action';
import GenericAction from '@Actions/generic-action';
import initialState from '@Context/common/general/initial-state';
import amplitude from 'amplitude-js';
import { Analytics } from 'firebase/analytics';
import { FirebaseApp } from 'firebase/app';
import { Auth } from 'firebase/auth';
import { Functions } from 'firebase/functions';
import { isUndefined } from 'lodash-es';

export enum CoreActions {
  UpdateState = 'UpdateState',
  Reset = 'Reset',
  CloseError ='CloseError',
  NoOp ='NoOp'
}

export type AppAction = (props: ActionProps) => any;

export type ActionConfig<T = any> = {
  type: typeof Action | typeof BaseApiAction | typeof GenericAction | CoreActions | T,
  payload?: any,
  disableLoaders?: boolean,
  cacheTime?: any,
  onSuccess?: (value:any) => any,
  onError?: (value:any) => any,
}

export type ActionTypeConfig<T = any> = {
  type: T,
  payload?: any,
  disableLoaders?: boolean,
  cacheTime?: any,
  onSuccess?: (value:any) => any,
  onError?: (value:any) => any,
}

export type DispatchType = (config: ActionConfig) => any;

export interface ActionProps {
  _firebase: FirebaseApp;
  _auth: Auth,
  _functions: Functions,
  _state: typeof initialState,
  _analytics: any,
  _amplitude: amplitude.AmplitudeClient,
  _sentry: ()=>void,
  _unityBridge: ()=>void,
  _dispatch: DispatchType,
  _payload: any,
  _onSuccess?: (value:any) => any,
  _onError?: (value:any) => any,
  _disableLoaders?: boolean
  _cacheTime?: any
}

export class Action implements ActionProps {
  constructor(
    public _firebase: FirebaseApp,
    public _auth: Auth,
    public _functions: Functions,
    public _state: typeof initialState,
    public _analytics: Analytics,
    public _amplitude: amplitude.AmplitudeClient,
    public _sentry: ()=>void,
    public _unityBridge: ()=>void,
    public _dispatch: DispatchType,
    public _payload: any,
    public _onSuccess?: (value:any) => any,
    public _onError?: (value:any) => any,
    public _disableLoaders?: boolean,
    public _cacheTime?: any)
  {
    this._firebase = _firebase;
    this._auth = _auth;
    this._dispatch = _dispatch;
    this._payload = _payload;
    this._state = _state;
    this._functions = _functions;
    this._analytics = _analytics;
    this._amplitude = _amplitude;
    this._sentry = _sentry;
    this._onSuccess = _onSuccess;
    this._onError = _onError;
    this._disableLoaders = _disableLoaders;
    this._cacheTime = _cacheTime;
    this.runAction();
    this.onLoad();
  };

  runAction() {}
  onLoad() {}

  onSuccess(response: any) {
    if( this._onSuccess ) {
      try {
        this._onSuccess(response);
      } catch(e) {
        console.error('Error in onSuccess', e);
      }
    }
  }

  onError(response: any) {
    if( this._onError ) {
      try {
        this._onError(response);
      } catch(e) {
        console.error('Error in onError', e);
      }
    }
  }

  addFieldIfExists(field: string, obj: any) {
    return isUndefined(obj) ? {} : {[field]: obj};
  }
};

export default Action;
